var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCam28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.49 5.771C3.49 5.957 2 7.656 2 9.665v8.67c0 2.009 1.49 3.708 3.49 3.894 1.54.143 3.322.271 4.76.271 1.438 0 3.22-.128 4.76-.271 2-.186 3.49-1.885 3.49-3.894v-8.67c0-2.009-1.49-3.708-3.49-3.894-1.54-.143-3.322-.271-4.76-.271-1.438 0-3.22.128-4.76.271Zm16.481 4.646A2 2 0 0 0 21 12.132v3.736a2 2 0 0 0 .971 1.715l2.015 1.209c1.056.633 2.395.155 2.639-1.052A19.02 19.02 0 0 0 27 14a19.02 19.02 0 0 0-.375-3.74c-.244-1.207-1.583-1.685-2.639-1.052l-2.015 1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.49 5.771C3.49 5.957 2 7.656 2 9.665v8.67c0 2.009 1.49 3.708 3.49 3.894 1.54.143 3.322.271 4.76.271 1.438 0 3.22-.128 4.76-.271 2-.186 3.49-1.885 3.49-3.894v-8.67c0-2.009-1.49-3.708-3.49-3.894-1.54-.143-3.322-.271-4.76-.271-1.438 0-3.22.128-4.76.271ZM21.971 10.417A2 2 0 0 0 21 12.132v3.736a2 2 0 0 0 .971 1.715l2.015 1.209c1.056.633 2.395.155 2.639-1.052A19.02 19.02 0 0 0 27 14a19.02 19.02 0 0 0-.375-3.74c-.244-1.207-1.583-1.685-2.639-1.052l-2.015 1.21Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCam28);
export default __webpack_public_path__ + "static/media/cam_28.499a3439.svg";
export { ForwardRef as ReactComponent };